import { supportedProfiles } from '../shared/constants';

export const isValidProfileType = (profileType) => supportedProfiles.includes(profileType);

export const isValid = () => true;
